'use client';

import Link from '@eliadmin/core/src/components/link';

import { useDialogStore } from '@eliadmin/core/src/components/ui/dialog';
import { Button } from '../ui/button';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { FaRegCircleUser } from 'react-icons/fa6';
import { SignInDialog } from "@eliadmin/core/src/components/dialog/lazy-dialogs";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@eliadmin/core/src/components/ui/dropdown-menu';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HEADER_CONFIG } from '@eliadmin/core/src/constants/header-config';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function MemberZoneButton() {
  const { t } = useTranslations();
  const me = useCustomerStore(s => s.me);
  const openDialog = useDialogStore(s => s.open);

  const handleSignInClick = () => {
    openDialog({
      id: SignInDialog.id,
      content: <SignInDialog />,
    });
  };

  if (!me) {
    return (
      <Button onClick={handleSignInClick} variant={'default-alt'}>
        <FaRegCircleUser size={20} /> {t('text2398')}
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={'default-alt'}>
          <FaRegCircleUser size={20} /> {t('text2398')}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className={cn(
          'flex w-fit max-w-[175px] flex-col items-start justify-start rounded-none border-none p-2.5',
          'ea-member-zone__dropdown-content',
        )}
      >
        {HEADER_CONFIG.memberItems.map((item, index) => {
          const LinkComponent = index === 1 ? 'a' : Link;
          const hrefString = typeof item.href === 'function' ? item.href() : item.href;

          return (
            <DropdownMenuItem
              asChild
              key={item.label}
              className="w-full cursor-pointer rounded-none hover:bg-neutral-50 hover:text-primary focus:bg-neutral-50 focus:text-primary"
            >
              <LinkComponent
                href={hrefString}
                className="flex items-center gap-2 text-sm font-normal text-primary lg:text-base"
              >
                {item.icon}
                {item.label}
              </LinkComponent>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
